import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import { makeStyles, Box, Typography } from '@material-ui/core';
import { coreRed } from '../../themeprovider/ccmTheme/colorPalette';

const useStyles = makeStyles(() => ({
  reCaptchaContainer: {
    margin: '30px auto 0',
  },
  error: {
    margin: '30px 0 10px',
    fontSize: '14px',
    color: coreRed,
  },
}));

const RecaptchaInput = (props) => {
  const { onChange, errorMessage } = props;
  const classes = useStyles();
  const [hasToken, setHasToken] = useState(false);

  return (
    <Box className={classes.reCaptchaContainer}>
      {errorMessage && !hasToken && (
        <Typography variant="body1" className={classes.error}>
          {errorMessage}
        </Typography>
      )}
      <ReCAPTCHA
        sitekey={process.env.GATSBY_RECAPTCHA_PUBLIC_KEY}
        onChange={(token) => {
          setHasToken(true);
          onChange(token);
        }}
      />
    </Box>
  );
};

RecaptchaInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

RecaptchaInput.defaultProps = {
  errorMessage: 'Recaptcha not verified',
};

export default RecaptchaInput;
